import { IUser } from './user.interface';

export interface IComment {
    id: string;
    codId: string;
    content: string;
    createdBy: string;
    createdAt: Date;
    updatedAt: Date;
    user?: IUser;
    attachmentKeys?: string[];
}
